<template>
	<div class="harness">
		<div class="harness-bar">
			<strong>Vue 2 form branding harness</strong>
			<label>Brand source <select v-model="mode"><option value="own">Form kit</option><option value="scheduler">Scheduler kit</option><option value="legacy">Legacy</option></select></label>
			<label>Appearance <select v-model="appearance"><option value="legacy">Legacy</option><option value="light">Light</option><option value="dark">Dark</option><option value="both">Both</option></select></label>
			<label>Choices <select v-model="ownBranding.choices.presentation"><option value="list">List</option><option value="cards">Cards</option><option value="pills">Pills</option></select></label>
			<label>Layout <select v-model="ownBranding.choices.layout"><option value="vertical">Vertical</option><option value="inline">Inline</option><option value="columns">Columns</option></select></label>
			<label><input v-model="complete" type="checkbox" /> Confirmation</label>
			<label><input v-model="inFrame" type="checkbox" /> Iframe spacing</label>
			<span>Local emits: {{ completionCount }}</span>
		</div>
		<main class="harness-stage">
			<form-v2 :key="`${mode}-${appearance}-${inFrame}-${ownBranding.choices.presentation}-${ownBranding.choices.layout}`" :form="activeForm" :font="activeForm.font" :complete="complete" :in-frame="inFrame" :disable-partial-data="true" @complete="onComplete" />
		</main>
	</div>
</template>

<script>
	import { cloneBranding, DEFAULT_BRANDING } from '@moxie/branding';
	import { resolveAppearanceBranding } from '@/utils/portalBranding';
	import FormV2 from '@/modules/forms/v2/FormV2';
	import { createFormBrandingFixture } from '@/dev/formBrandingFixture';

	export default {
		name: 'FormBrandingHarnessPage',
		components: { FormV2 },
		provide() { return { schedulerBranding: () => this.schedulerResolved, schedulerAppearance: () => this.schedulerEffectiveAppearance }; },
		data() {
			const ownBranding = cloneBranding(DEFAULT_BRANDING);
			ownBranding.choices.presentation = 'cards';
			ownBranding.choices.layout = 'columns';
			ownBranding.buttons.width = 'content';
			ownBranding.buttons.alignment = 'right';
			const schedulerBranding = cloneBranding(DEFAULT_BRANDING);
			schedulerBranding.colors.primary = '#6d28d9';
			schedulerBranding.colors.background = '#f5f3ff';
			schedulerBranding.colors.text = '#2e1065';
			schedulerBranding.choices.presentation = 'pills';
			return { mode: 'own', appearance: 'legacy', complete: false, inFrame: false, completionCount: 0, form: createFormBrandingFixture(), ownBranding, schedulerBranding };
		},
		computed: {
			activeForm() {
				const branding = this.mode === 'own' ? { ...this.ownBranding } : null;
				if (branding && this.appearance !== 'legacy') branding.appearance = this.appearance;
				return { ...this.form, branding };
			},
			schedulerResolved() {
				if (this.mode !== 'scheduler') return null;
				const branding = { ...this.schedulerBranding };
				if (this.appearance !== 'legacy') branding.appearance = this.appearance;
				return resolveAppearanceBranding(branding, this.$vuetify.theme.dark ? 'dark' : 'light');
			},
			schedulerEffectiveAppearance() {
				if (this.appearance === 'light' || this.appearance === 'dark') return this.appearance;
				return this.$vuetify.theme.dark ? 'dark' : 'light';
			},
		},
		mounted() { window.__formBrandingHarness = this; },
		beforeDestroy() { delete window.__formBrandingHarness; },
		methods: { onComplete() { this.completionCount += 1; this.complete = true; } },
	};
</script>

<style scoped lang="scss">
	.harness { min-height: 100vh; background: #e9ece9; }
	.harness-bar { position: sticky; top: 0; z-index: 20; display: flex; flex-wrap: wrap; align-items: center; gap: 16px; padding: 10px 16px; color: #fff; background: #17211e; font: 13px Inter, sans-serif; }
	.harness-bar label { display: inline-flex; align-items: center; gap: 6px; }
	.harness-stage { width: min(900px, 100%); margin: 0 auto; padding: 24px; }
	@media (max-width: 640px) { .harness-stage { padding: 0; } }
</style>
